import { useRef } from 'react';

import { Button, cn, Separator, Table } from 'twyne-new.ui';

import { useColumnSizeVariables } from '@/components/tableResize/hooks';
import { useGrid } from '@Components/Grid/context';

import Pagination from "./Pagination";
import { useTableContext } from './context';

export default function TableWrapper({ children }) {
  const tableRef = useRef(null)
  const { definitions: { enableTableResize = true } } = useGrid()

  return <div ref={tableRef} className='sm:pl-5 md:pl-2 relative z-0'>
    <ActionsCheckboxes />
    {enableTableResize ? <ResizableTable tableRef={tableRef}>{children}</ResizableTable> : <Table className='w-full table-fixed'>{children}</Table>}
    <Pagination />
  </div>
}

function ResizableTable({ children, tableRef }) {
  const columnSizeVariables = useColumnSizeVariables({ tableRef, tableContext: useTableContext })

  return <Table className='w-full table-fixed' style={{ ...columnSizeVariables }}>
    {children}
  </Table>
}

function ActionsCheckboxes() {
  const { rowsSelected, definitions } = useGrid()
  const { entityNamePlural, entityName } = definitions
  const selectedCount = rowsSelected.length
  const showBulkHeader = selectedCount > 0

  return <div className={cn(
    'w-full flex items-center px-5 gap-2 overflow-hidden transition-all duration-200 ease-in-out',
    showBulkHeader ? 'max-h-14 py-3 opacity-100 translate-y-0 border-b twy-border-base' : 'max-h-0 py-0 opacity-0 -translate-y-1 border-b border-transparent pointer-events-none')
  }>
    <span className='twy-text-base-accent'>Edit Selected</span>
    <Button variant='outline' size='sm'>Active</Button>
    <Separator orientation='vertical' className='py-2' />
    <div>
      <span className='twy-text-base-accent mr-1'>{selectedCount}</span>
      <span>{rowsSelected.length === 1 ? entityName : entityNamePlural} selected.</span>
    </div>
  </div>
}
